// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_GetPriceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_priorities/get_price/{service_id}/{priority_id}
 *
 * Single (price, deadline_days) pair for a specific service+priority combo.
 * Wire shape: `dados: { price: int, deadline_days: int }` — emitted directly
 * from the model's SELECT row (price stored in centavos, not divided).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ServicePriorities_GetPriceResponseDados {
price: number
deadline_days: number
}

export type ServicePriorities_GetPriceResponse = ApiResponse<ServicePriorities_GetPriceResponseDados>;

registerResponseContract('ServicePriorities_GetPriceResponse', {
  price:         { type: 'number',  required: false },
  deadline_days: { type: 'number',  required: false },
})
